export const UPGRADE = 'upgrade';
export const PURCHASE = 'purchase';
export const MONTHLY = 'monthly';
export const YEARLY = 'yearly';
export const ANNUALLY = 'annually';
export const MONTHLY_TEXT = 'Monthly';
export const YEARLY_TEXT = 'Annual';
export const ELIGIBILITY_ACTION_UPGRADE = 'UPGRADE';
export const ELIGIBILITY_ACTION_PURCHASE = 'PURCHASE';
export const ELIGIBILITY_ACTION_EXTERNAL = 'EXTERNAL';
export const ELIGIBILITY_ACTION_VIPOPS = 'VIPOPS';
export const ELIGIBILITY_ACTION_NO_UPGRADE = 'NOUPGRADE';
export const ELIGIBILITY_ACTION_EXTERNAL_OPIN = 'EXTERNAL-OPIN';
